//
export default [
    {
        text: "#",
        value: "id",
        //sortable: true,
    },
    {
        text: "rut",
        value: "rut",
        sortable: true,
        format: "rut",
        width: "200px",
    },
    {
        text: "razón social",
        value: "business_name",
        sortable: true,
    },
    {
        text: "nombre",
        value: "alias_name",
        sortable: true,
    },
    {
        text: "sucursales",
        value: "pch_provider_branch_offices_addresses",
        sortable: "address",
        component: {
            type: "chip-list",
            props: {
                disabled: true,
                label: true,
                small: true,
                textColor: "black",
            },
        },
    },
    {
        text: "fecha de creación",
        value: "created_at",
        align: "right",
    },
]